import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const InnerWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 16px;
  column-gap: 16px;
  margin-bottom: 24px;

  @media (max-width: ${defaultBreakpoints.medium}) {

  }
`;
export const Wrapper = styled.div`
  margin: 1rem 0;
  .title {
    font-family: ${({ theme }) => theme.default.fontFamily.primaryFont};
    font-size: 12px;
    font-weight: 800;
    line-height: 12px;
    text-transform: uppercase;
    margin-bottom: 16px;  
  }
`;

export const RelatedArticleItem = styled.div`
  display: flex;
  cursor: pointer;
  background: ${({ theme }) => theme.default.color.backgrounds.offWhite};
  border-radius: 20px;

  @media (max-width: ${defaultBreakpoints.medium}) {
    flex-direction: column;
    height: 100%;  
  }
`;

export const RelatedArticleText = styled.span`
  font-family: ${({ theme }) => theme.default.fontFamily.primaryFont};
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  margin: auto 12px;
  color: ${({ theme }) => theme.default.color.text.dark};
  :hover {
    color: ${({ theme }) => theme.default.color.primary};
    text-decoration: underline;
  }
  @media (max-width: ${defaultBreakpoints.medium}) {
      margin: 0;
      padding: 10px;
  }
`;

export const Image = styled.img`
  object-fit: cover;
  width: 127px;
  height: 96px;
  border-radius: 20px 0 0 20px;
  @media (max-width: ${defaultBreakpoints.medium}) {
    border-radius: 20px 20px 0 0;
    width: 100%;
    height: 150px;  
  }

`;
